import React, { useState, useEffect, Fragment } from 'react';
import { Row } from 'reactstrap';
import { Card, CardBody, Button } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import './css/property.scss';
import MessageResponse from './ResponseBlock/MessageResponse';
import LinkResponse from './ResponseBlock/LinkResponse';
import ImageCarouselResponse from './ResponseBlock/ImageCarouselResponse';
import VideoResponse from './ResponseBlock/VideoResponse';
import Sidemenu from './Sidemenu/Sidemenu';
import PublishGPT from '../components/PublishGPT/PublishGPT';
import no_fav from '../../../../../assets/pre-built-templates.png'
import { RotateSpinner } from 'react-spinners-kit';

import ExampleResponse from './ResponseBlock/ExampleResponse';
import {
  postAPI_TrackEvent,
  gAPI_Favourite,
  gAPI_Users_By_Id,
  gAPI_Property_List_By_Group
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../helpers/AxiosAPI';

function ResponseBlock({ getUrl, propertyId, locale, domains, email, missingCode, lang, isSuperAdmin }) {
  const [responseData, setResponseData] = useState(null);
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [FavResult, setFavResult] = useState([]);
  const [userRole, setUserRole] = useState("Admin");
  const [userName, setUserName] = useState("");
  const [propertyList, setPropertyList] = useState([]);
  const [isLoadingSearch, setIsLoadingSearch] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(lang);
  const [isButtonShow, setIsButtonShow] = useState(true);
  const [filledCount, setFilledCount] = useState(0);
  const [blankCount, setBlankCount] = useState(0);
  const [filters, setFilters] = useState({ filled: false, blank: false });
  const reloadBotResponse = async () => {
    let url = `${getUrl}/?property_id=${propertyId}&group_id=${getGroupID()}&lang=${locale === 'en' ? 'en-US' : locale
      }`;

    if (missingCode !== undefined) {
      url = url + `&code=${missingCode === undefined ? '' : missingCode}`;
    }

    setIsLoading(true);
    locale = lang;
    var languageCode = locale;
    if (locale === "zh-TW") {
      languageCode = "hk";
    }
    if (locale === "en") {
      languageCode = "en-US";
    }
    return await AxiosAPI({
      methed: 'get',
      url: `${getUrl}/?property_id=${propertyId}&group_id=${getGroupID()}&lang=${languageCode}&code=${missingCode === undefined ? '' : missingCode}`,
    })
      .then((res) => {

        setResult(res.data);
        let filled = 0;
        let blank = 0;

        res.data.forEach((item) => {
          if (item.response?.isExample === true) {
            blank++;
          } else {
            filled++;
          }
        });


        setFilledCount(filled);
        setBlankCount(blank);
        if (propertyId !== '-1') {
          AxiosAPI({
            methed: 'get',
            url: `${gAPI_Favourite}?property_id=${propertyId}&group_id=${getGroupID()}&lang=${languageCode
              }`,
          })
            .then((res) => {
              setFavResult(res.data);
              setIsLoading(false);
              //console.log('fav Bot Response', res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          setIsLoading(false);
        }
        //console.log('All Bot Response', res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const GetProperties = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      setUserName(res.data.fullName);
      var admin = false;
      var user = false;
      var agent = false;
      var sa = false;
      res.data.roles.forEach((r) => {
        if (r === 'User') {
          user = true;
          setUserRole('User');
        }
        if (r === 'Admin') { admin = true; }
        if (r === 'Agent') { agent = true; }
        if (r === 'SuperAdmin' || isSuperAdmin) { sa = true; }
      });
      if (sa === false && admin === false && user === false && agent === true) {
        setIsButtonShow(false);
      }

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}?group_id=${getGroupID()}`,
      }).then((pres) => {
        var PropertyList = pres.data.filter(i => i.id !== propertyId);
        const finalResult = [];
        var domainName = "";
        if (Array.isArray(domains)) {
          var list = domains.filter((elem) => elem.priority === 1 && elem.type !== "VoucherEngine");
          if (list.length > 0) {
            domainName = list[0].type;
          }
        }
        if (res.data.properties.length > 0 && res.data.properties[0] === "-1") {
          PropertyList.forEach((p) => {
            let checkDomain = p.domains.filter(j => j.type.includes(domainName));
            if (domainName !== "" && checkDomain !== undefined && checkDomain.length > 0) {
              finalResult.push({
                id: p.id,
                name: p.name,
                domains: p.domains
              });
            }
          });
        }
        else {
          PropertyList.forEach((p) => {
            res.data.properties.forEach((r) => {
              let checkDomain = p.domains.filter(j => j.type.includes(domainName));
              if (domainName !== "" && p.id === r && checkDomain !== undefined && checkDomain.length > 0) {
                finalResult.push({
                  id: p.id,
                  name: p.name,
                  domains: p.domains
                });
              }
            });
          });
        }
        setPropertyList(finalResult);

      }).catch((err) => console.error(err));
    }).catch((err) => console.error(err));
  }
  useEffect(() => {
    if (domains && domains.length > 0) {
      GetProperties();
    }
  }, [domains, lang]);

  useEffect(() => {
    locale = lang;
    var languageCode = locale;
    if (locale === "zh-TW") {
      languageCode = "hk";
    }
    if (locale === "en") {
      languageCode = "en-US";
    }
    setSelectedLanguage(languageCode);
    if (propertyId !== "-1") {
      reloadBotResponse();
    }
    else {
      setResult([]);
      setIsLoading(false);
    }
    if (email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Knowledge Hub',
          email: email,
        },
      }).then(
        (res) => { },
        (error) => {
          console.log(error);
        }
      );
    }
  }, [lang]);



  useEffect(() => {
    setResponseData(result);
  }, [result, lang]);

  const onSearchKey = (e) => {
    setIsLoadingSearch(true);
    var serachtext = e.target.value.toLowerCase();
    var resdata = result.filter(a => a.query.code.toLowerCase().includes(serachtext)
      || a.query.hintQuestion.toLowerCase().includes(serachtext)
      || a.response.messages.join(",").toLowerCase().includes(serachtext)
    );
    setTimeout(() => {
      setResponseData(resdata);
      setIsLoadingSearch(false);
    }, 1000);
  };

  const handleFilterChange = (selectedFilters) => {
    const newFilters = {
      filled: selectedFilters.includes('Filled'),
      blank: selectedFilters.includes('Blank'),
    };
    setFilters(newFilters);
  };


  const generator = () => {

    if (responseData && FavResult) {
      const filteredData = responseData.filter(item => {
        if (filters?.filled && item.response?.isExample === false) return true;
        if (filters?.blank && item.response?.isExample === true) return true;
        return !filters?.filled && !filters?.blank;
      });

      return filteredData.map((elem, index) => {
        const favarr = FavResult.filter((m) => m.query.code === elem.query.code);

        let fav = false;
        if (favarr.length > 0) {
          fav = true;
        }

        switch (elem.response.type) {
          case 'example':
            return (
              <Fragment key={index}>
                <ExampleResponse
                  favouriteResponse={fav}
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={true}
                  userRole={userRole}
                  historyUpdator={userName}
                  propertyList={propertyList}
                  selectedLang={selectedLanguage}
                  isButtonShow={isButtonShow}
                />
              </Fragment>
            );

          case 'messages':
            return (
              <Fragment key={index}>
                <MessageResponse
                  favouriteResponse={fav}
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={true}
                  userRole={userRole}
                  historyUpdator={userName}
                  propertyList={propertyList}
                  selectedLang={selectedLanguage}
                  isButtonShow={isButtonShow}
                />
              </Fragment>
            );

          case 'messages-link':
            return (
              <Fragment key={index}>
                <LinkResponse
                  favouriteResponse={fav}
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={true}
                  userRole={userRole}
                  historyUpdator={userName}
                  propertyList={propertyList}
                  selectedLang={selectedLanguage}
                  isButtonShow={isButtonShow}
                />
              </Fragment>
            );

          case 'messages-image-carousel':
            return (
              <Fragment key={index}>
                <ImageCarouselResponse
                  favouriteResponse={fav}
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={true}
                  userRole={userRole}
                  historyUpdator={userName}
                  propertyList={propertyList}
                  selectedLang={selectedLanguage}
                  isButtonShow={isButtonShow}
                />
              </Fragment>
            );
          case 'messages-video':
            return (
              <Fragment key={index}>
                <VideoResponse
                  favouriteResponse={fav}
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={true}
                  userRole={userRole}
                  historyUpdator={userName}
                  propertyList={propertyList}
                  selectedLang={selectedLanguage}
                  isButtonShow={isButtonShow}
                />
              </Fragment>
            );
          default:
            break;
        }
      });
    } else return null;
  };

  return (
    <Fragment>
      {isLoading ? (
        <Row>
          <Colxx xxs="5" className="mb-2"></Colxx>
          <Colxx xxs="2" className="mb-2">
            <RotateSpinner size={60} color="#4556AC" loading={isLoading} />
          </Colxx>
          <Colxx xxs="5" className="mb-2"></Colxx>
        </Row>
      ) : (
        <Fragment>
          <Row className="">
            {/* <Colxx xxs="3" xs="3">
            </Colxx> */}
            <Colxx xxs="2" xs="3">
              <div
                className="search-sm d-inline-block float-md-left mr-1  align-top"
                style={{ width: '100%' }}
              >
                <input
                  type="text"
                  name="keyword"
                  id="search"
                  placeholder="Search for amemities, pools, food and more"
                  onKeyUp={(e) => onSearchKey(e)}
                  style={{ width: '100%' }}
                />
              </div>
            </Colxx>
            <Colxx xxs="2" xs="3">
              {/* GPT Publish Button START  */}
              {/* {(getGroupID() === "a7e06370-a3bc-43ef-ba88-afb100137eca" ||
                getGroupID() === "af402810-8902-473b-a487-b04301549dac") &&
                (
                  <div>
                    {locale && locale === 'en' && <a href="/app/pages/propinfo/publish-ai">
                      <Button
                        color="primary"
                        outline
                        className='ml-2'
                        size="xs"
                      >
                        Publish AI
                      </Button>
                    </a>}
                  </div>)

              } */}
              {(getGroupID() !== "a7e06370-a3bc-43ef-ba88-afb100137eca" &&
                getGroupID() !== "af402810-8902-473b-a487-b04301549dac" &&
                locale === "en") &&
                (<a href="/app/pages/propinfo/publish-ai">
                  <Button
                    color="primary"
                    outline
                    size="xs"

                  >
                    Publish AI
                  </Button>
                </a>
                  // <PublishGPT></PublishGPT>
                )
              }
            </Colxx>
            <Colxx xxs="6" xs="6">
            </Colxx>
          </Row>
          <Colxx xxs="10" >
            <strong><hr /></strong>
          </Colxx>

          <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">

            <Row>
              <Colxx
                xxs="10"
                md="10"
                lg="10"
                className="mb-2 col-sm-12"
                style={{ paddingLeft: '0px', paddingRight: '5px' }}
              >
                {result && result.length > 0 ? (
                  <Card>
                    <CardBody>
                      {!isLoadingSearch ?

                        generator()

                        : <Row>
                          <Colxx xxs="5" className="mb-2"></Colxx>
                          <Colxx xxs="2" className="mb-2">
                            <RotateSpinner size={60} color="#4556AC" loading={isLoadingSearch} />
                          </Colxx>
                          <Colxx xxs="5" className="mb-2"></Colxx>
                        </Row>}
                    </CardBody>
                  </Card >
                ) :

                  <Colxx xxs="12" className="mb-4 text-center">
                    <img className='w-40' style={{ marginTop: '5rem' }} src={no_fav}></img></Colxx>
                }
              </Colxx>
              <Colxx xxs="2" lg='2'>

                <Sidemenu allCount={result}
                  filledCount={filledCount && filledCount != null ? filledCount : 0}
                  blankCount={blankCount && blankCount != null ? blankCount : 0}
                  onFilterChange={handleFilterChange} />
              </Colxx>
            </Row>
          </Colxx>

        </Fragment>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings, usersListApp }) => {
  const { propertyId, locale, email, domains } = settings;
  const { isSuperAdmin } = usersListApp;
  return {
    propertyId,
    locale,
    email,
    domains,
    isSuperAdmin,
  };
};

export default injectIntl(connect(mapStateToProps)(ResponseBlock));
